import React, {Fragment, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FileExport from "../FileExport";
import IPSDTFileExport from "components/FileExport/IPSDTFileExport";

export default function IPSDTViewType(props) {
    const { onViewTypeChange, tabView ,dtstatus} = props;
    const [viewType, setViewType] = useState('cardview');

    let listIconStyle = {
      fontSize: 30,
      cursor: "pointer",
      color: viewType === 'cardview' ? "#c0c0c0" : "black"
    };
    let cardIconStyle = {
      fontSize: 30,
      cursor: "pointer",
      color: viewType === 'cardview' ? "black" : "#c0c0c0"
    };

    function onClick(event, viewType) {
        setViewType(viewType);
        onViewTypeChange(viewType);
    }

    return (
        <Fragment>
            <FontAwesomeIcon
                icon="th"
                style={cardIconStyle}
                onClick={(event) => onClick(event, "cardview")}
            />
            <span className="space-20"/>
            <FontAwesomeIcon
                icon="list"
                style={listIconStyle}
                onClick={(event) => onClick(event, "listview")}
            />
            <span className="space-20"/>
            <IPSDTFileExport tabView={tabView} dtstatus={ dtstatus} />
        </Fragment>
    )
}
